<template>
    <b-container class="bv-example-row">
        <b-row class="justify-content-center align-items-center">
            <b-card class="col-lg-5 col-md-7 mt-5" bg-variant="light">
                <b-card-body class="px-lg-5 py-lg-1">
                    <template v-if="submitted">
                        <b-card-text class="text-center text-muted mb-4 mt-4">
                            <h5 class="display-4">Password Changed!</h5>
                        </b-card-text>
                        <b-card-text class="text-center text-muted mb-4 mt-4">
                            We have sent a recovery email to you. Please
                            continue the password recovery process there.
                        </b-card-text>
                        <b-row class="justify-content-center">
                            <b-button variant="primary" @click="backToLogin()"
                                >Back To Login</b-button
                            >
                        </b-row>
                    </template>
                    <template v-else>
                        <b-card-text class="text-center text-muted mb-4 mt-4">
                            <h5 class="display-4">Reset Your Password</h5>
                        </b-card-text>
                        <b-card-text class="text-center text-muted mb-4">
                            <small>Reset your email address and password</small>
                        </b-card-text>
                        <b-alert variant="danger" :show="errors.has('token')">{{
                            errors.first('token')
                        }}</b-alert>

                        <b-form role="form" submit.prevent="login">
                            <input type="hidden" name="token" />
                            <b-form-group
                                class="mb-3"
                                label="Email"
                                label-for="forgot-password-email"
                                name="email"
                                :error="errors.first('email')"
                            >
                                <b-form-input
                                    v-model="model.email"
                                    v-validate="'required|email'"
                                    type="email"
                                    id="forgot-password-email"
                                ></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="Password"
                                name="password"
                                label-for="forgot-password-password"
                                :error="errors.first('password')"
                                ref="password"
                            >
                                <b-form-input
                                    id="forgot-password-password"
                                    type="password"
                                    v-model="model.password"
                                    v-validate="'required|min:6'"
                                >
                                </b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="Retype Password"
                                type="password"
                                label-for="forgot-password-confirm-password"
                                name="confirmPassword"
                                :error="errors.first('confirmPassword')"
                            >
                                <b-form-input
                                    type="password"
                                    v-model="model.password_confirmation"
                                    id="forgot-password-confirm-password"
                                    v-validate="
                                        'required|min:6|confirmed:password'
                                    "
                                ></b-form-input
                            ></b-form-group>
                            <div class="text-right">
                                <b-button
                                    class="my-4"
                                    variant="primary"
                                    :disabled="submitting ? true : false"
                                    @click="submit()"
                                    >{{
                                        submitting
                                            ? 'Submitting...'
                                            : 'Recover Your Password'
                                    }}</b-button
                                >
                            </div>
                        </b-form>
                    </template>
                </b-card-body>
            </b-card>
        </b-row>
    </b-container>
</template>
<script>
import api from '@/api/auth'

export default {
    name: 'change-password',
    data() {
        return {
            submitting: false,
            signInError: false,
            // if successfully submitted
            submitted: false,
            model: {
                email: 'admin@oms.com',
                password: 'password',
                password_confirmation: 'password',
            },
        }
    },
    methods: {
        submit() {
            this.$validator.validate().then(() => {
                this.submitting = true
                api.resetPassword({
                    ...this.model,
                    token: this.$route.query.token,
                })
                    .then(() => {
                        // route to dashboard
                        this.submitted = true
                    })
                    .catch(error => {
                        let messages = error.response.data.error.message
                        // show error
                        this.signInError = true
                        for (let field in messages) {
                            for (let e of messages[field]) {
                                this.$validator.errors.add({
                                    scope: null,
                                    field: field,
                                    msg: e,
                                })
                            }
                        }
                    })
                    .finally(() => {
                        this.submitting = false
                    })
            })
        },
        backToLogin() {
            this.$router.push('/login')
        },
    },
}
</script>
<style></style>
